import React, { Component } from "react";

export default class Button extends Component {
  render() {
    return (
      <button
        className="btn btn-primary text-center"
        style={{
          marginLeft: 10,
          marginRight: 10,
          height: 30,
          padding: "0px 10px 0px 10px",
        }}
        onClick={this.props.onClick}
        disabled={this.props.isDisabled}
      >
        {this.props.label}
      </button>
    );
  }
}
